// FIXME: Update this configuration file based on your project information

export const AppConfig = {
  site_name: 'PickTheBank',
  title: 'PickTheBank',
  description:
    'Find and compare the best deposit accounts in the EU. Discover high interest deposit accounts, secure online deposit accounts, and learn about the Deposit Guarantee Scheme.',
  locale: 'en',
};
